export const LoadingFunds = () => (
  <div>
    {new Array(18).fill(0).map((_, index) => (
      <div className="grid grid-cols-5 animate-pulse my-4" key={index}>
        <div className="h-4 bg-grey rounded-full dark:bg-grey mr-6" />
        <div className="h-4 bg-grey rounded-full dark:bg-grey ml-2" />
        <div className="h-4 bg-grey rounded-full dark:bg-grey mr-2 ml-6" />
        <div className="h-4 bg-grey rounded-full dark:bg-grey mr-2 ml-2" />
        <div className="h-4 bg-grey rounded-full dark:bg-grey ml-2 " />
      </div>
    ))}
  </div>
);
